import { render, staticRenderFns } from "./budget-header-new.vue?vue&type=template&id=d5cd0934&scoped=true&"
import script from "./budget-header-new.vue?vue&type=script&lang=ts&"
export * from "./budget-header-new.vue?vue&type=script&lang=ts&"
import style0 from "./budget-header-new.vue?vue&type=style&index=0&id=d5cd0934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cd0934",
  null
  
)

export default component.exports